import React from 'react';
import { Tag, Tooltip, Typography } from 'antd';
import {
	AddIcCallOutlined,
	CallOutlined,
	ChatBubbleOutlineOutlined,
	EmailOutlined,
} from '@mui/icons-material';
import { InfoCircleOutlined } from '@ant-design/icons';
import { AICampaignFormData } from '../types';

const { Title } = Typography;

interface StepTwoProps {
	formData: AICampaignFormData;
	setFormData: React.Dispatch<React.SetStateAction<AICampaignFormData>>;
	handleInputChange: (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
}

const StepTwo: React.FC<StepTwoProps> = ({ formData, handleInputChange }) => {
	return (
		<div className="step-content">
			<div className="flex">
				{/* <TargetIcon size={36} className='text-blue-600 mr-3' /> */}
				<Title className="my-0" level={2}>
					What kind of campaign do you want to build?
				</Title>
			</div>
			<p>Choose how you want to reach your leads. Each method has different advantages.</p>
			<div className="campaign-types">
				<div
					className={`relative campaign-type-option ${formData.campaignType === 'outbound-calls' ? 'selected' : ''}`}
				>
					<input
						type="radio"
						id="outbound-calls"
						name="campaignType"
						value="outbound-calls"
						checked={formData.campaignType === 'outbound-calls'}
						onChange={handleInputChange}
						style={{ display: 'none' }}
						required
					/>
					<label htmlFor="outbound-calls" className="block relative">
						<div className="flex items-center">
							<CallOutlined fontSize="large" className="text-blue-600" />
							<div className="ml-3">
								<p className="my-0 mb-1 text-lg font-medium">Outbound Calling</p>
								<p className="my-0 text-gray-500">
									Our AI automatically calls leads and engages them in natural conversations.
								</p>
							</div>
						</div>
					</label>

					{/* Tooltip Icon at Top-Right */}
					<Tooltip title="More information about Outbound Calling">
						<InfoCircleOutlined className="absolute top-3 right-3 text-gray-500 text-md cursor-pointer" />
					</Tooltip>
				</div>

				<div
					className={`relative campaign-type-option ${formData.campaignType === 'outbound-texting' ? 'selected' : ''}`}
				>
					<input
						type="radio"
						id="outbound-texting"
						name="campaignType"
						value="outbound-texting"
						checked={formData.campaignType === 'outbound-texting'}
						onChange={handleInputChange}
						style={{ display: 'none' }}
						required
					/>
					<label htmlFor="outbound-texting" className="block relative">
						<div className="flex items-center">
							<ChatBubbleOutlineOutlined fontSize="large" className="text-green-600" />
							<div className="ml-3">
								<p className="my-0 mb-1 text-lg font-medium">Outbound Texting</p>
								<p className="my-0 text-gray-500">
									Our AI sends personalized text messages and responds to the replies.
								</p>
							</div>
						</div>
					</label>

					{/* Tooltip Icon at Top-Right */}
					<Tooltip title="More information about Outbound Texting">
						<InfoCircleOutlined className="absolute top-3 right-3 text-gray-500 text-md cursor-pointer" />
					</Tooltip>
				</div>

				<div
					className={`relative campaign-type-option ${formData.campaignType === 'outbound-calls-texting' ? 'selected' : ''}`}
				>
					<input
						type="radio"
						id="outbound-calls-texting"
						name="campaignType"
						value="outbound-calls-texting"
						checked={formData.campaignType === 'outbound-calls-texting'}
						onChange={handleInputChange}
						style={{ display: 'none' }}
						required
					/>
					<label htmlFor="outbound-calls-texting" className="block relative">
						<div className="flex items-center">
							<AddIcCallOutlined fontSize="large" className="text-purple-600" />
							<div className="ml-3">
								<p className="my-0 mb-1 text-lg font-medium">Calling + Texting</p>
								<p className="my-0 text-gray-500">
									Combined approach with calls and follow-up texts for maximum engagements.
								</p>
							</div>
						</div>
					</label>

					{/* Tooltip Icon at Top-Right */}
					<Tooltip title="More information about Calling & Texting">
						<InfoCircleOutlined className="absolute top-3 right-3 text-gray-500 text-md cursor-pointer" />
					</Tooltip>
				</div>

				<div className={`relative campaign-type-option disabled`}>
					<input
						type="radio"
						id="outbound-calls"
						name="campaignType"
						value="outbound-calls"
						checked={formData.campaignType === 'outbound-calls'}
						onChange={handleInputChange}
						style={{ display: 'none' }}
						disabled
						required
					/>
					<label htmlFor="outbound-calls" className="block relative">
						<div className="flex items-center">
							<EmailOutlined fontSize="large" className="text-gray-600" />
							<div className="ml-3">
								<p className="my-0 mb-1 text-lg font-medium">
									Outbound Emails(Coming Soon) <Tag>Coming Soon</Tag>
								</p>
								<p className="my-0 text-gray-500">
									AI powered email campaigns with smart follow-ups.
								</p>
							</div>
						</div>
					</label>

					{/* Tooltip Icon at Top-Right */}
					<Tooltip title="More information about Outbound Emails">
						<InfoCircleOutlined className="absolute top-3 right-3 text-gray-500 text-md cursor-pointer" />
					</Tooltip>
				</div>
			</div>
		</div>
	);
};

export default StepTwo;
